import React from "react";

const ZoneDropdown = (props) => {
    const { selectedzone, zones , onZoneChange} = props;


    const handleZoneChange = (event) => {
        
        const newZoneID = event.target.value;
            // Find the selected zone object based on the ID
            const selectedZone = zones.find((zone) => zone.iZoneID === + newZoneID);
            // Call the parent's callback function with the selected zone name
            onZoneChange(newZoneID, selectedZone ? selectedZone.vZoneName : '');
    };
        // Find the zone object that matches the Selectedzone name
    const selectedZone = zones.find((zone) => zone.vZoneName === selectedzone);

  return (
    <select className="form-select form-control" 
    value={selectedZone ? selectedZone.iZoneID : ''} 
    onChange={handleZoneChange}>
      <option value="">Select a zone</option>
      {zones.map((zone) => (
        <option key={zone.iZoneID} value={zone.iZoneID}>
          {zone.vZoneName}
        </option>
      ))}
    </select>
  );
};

export default ZoneDropdown;